import MarkdownIt from "markdown-it";

const markdown = new MarkdownIt({
  html: false,
  linkify: true,
  breaks: true,
});

export const markdownToHtml = (value?: string) => markdown.render(value || "");
